import { createContext, ReactNode, useContext, useMemo, useState } from 'react'
import { Dayjs } from 'dayjs'
import { ScheduleMode } from './scheduleModel'

export type ScheduleHeaderState = {
  view: ScheduleMode
  selectedDate: Dayjs
}

type ScheduleHeaderActionsContextType = {
  headerState: ScheduleHeaderState | null
  setHeaderState: (state: ScheduleHeaderState) => void
}

const ScheduleHeaderActionsContext = createContext<ScheduleHeaderActionsContextType>({
  headerState: null,
  setHeaderState: () => { /* no provider means the page header shows no schedule actions */ }
})

type Props = {
  children: ReactNode
}

/// The schedule toolbar is full, so page-level actions live in the tab bar beside Give Feedback.
/// That sits above ScheduleContent, which owns the view and selected date, so those are published
/// upward rather than duplicating the reducer.
export const ScheduleHeaderActionsProvider = ({ children }: Props) => {
  const [headerState, setHeaderState] = useState<ScheduleHeaderState | null>(null)
  const value = useMemo(() => ({ headerState, setHeaderState }), [headerState])

  return (
    <ScheduleHeaderActionsContext.Provider value={value}>
      {children}
    </ScheduleHeaderActionsContext.Provider>
  )
}

export const useScheduleHeaderActions = () => useContext(ScheduleHeaderActionsContext)
